<template>
  <div class="modal-column">
    <div class="modal-column-full-body">
      <Form ref="form" :model="form" :rules="{}" labelWidth="150">
        <div class="ml-20px font-bold mb-16px">基本信息</div>
        <div class="inline-form-item">
          <FormItem label="资产编码" prop="code" required>
            <Input type="text" v-model="form.code" :disabled="disabled"/>
          </FormItem>
          <FormItem label="资产名称" prop="name" required>
            <Input type="text" v-model="form.name"/>
          </FormItem>
          <FormItem label="资产类别" prop="assetsTypeId" required>
            <Select :deletable="false" :datas="assetsTypeList" keyName="id" titleName="name" filterable
                    v-model="form.assetsTypeId">
              <template v-slot:item="{ item }">
                {{ item.code }} {{ item.name }}
              </template>
            </Select>
          </FormItem>
        </div>
        <div class="inline-form-item">
          <FormItem label="增加方式" prop="addType" required>
            <Select :deletable="false" v-model="form.addType" :datas="{1:'购入',2:'在建工程转入',3:'其他'}"/>
          </FormItem>
          <FormItem label="开始使用日期" prop="startDate" required>
            <DatePicker v-model="form.startDate" :disabled="disabled"></DatePicker>
          </FormItem>
          <FormItem label="使用部门" prop="deptId" required>
            <!-- 弹出新增部门 -->
            <div style="display:flex;flex-direction:row;align-items:center;">
              <Select :datas="deptLists" filterable v-model="form.deptId" :disabled="disabled"/>
              <Button icon="fa fa-plus" @click="openDept"></Button>
            </div>
          </FormItem>
        </div>
        <div class="inline-form-item">
          <FormItem label="规格型号" prop="specification">
            <Input type="text" v-model="form.specification"/>
          </FormItem>
          <FormItem label="供应商" prop="supplierId">
            <Input type="text" v-model="form.supplier"/>
          </FormItem>
          <FormItem label="录入期间" prop="entryDate">
            <DatePicker disabled v-model="form.entryDate"></DatePicker>
          </FormItem>
        </div>
        <div class="ml-20px font-bold mb-16px">折旧方式</div>
        <div class="inline-form-item">
          <FormItem label="折旧方法" prop="depreciationMethod" required>
            <Select :deletable="false" v-model="form.depreciationMethod" :disabled="disabled"
                    :datas="depreciationMethods" keyName="code" titleName="name"></Select>
          </FormItem>
          <FormItem label="录入当期是否折旧" prop="isPeriod" required>
            <Radio :disabled="form.depreciationMethod" v-model="form.isPeriod" dict="defaultRadios"/>
          </FormItem>
          <FormItem label="资产科目" prop="assetsSubjectCode" required>
            <Select :deletable="false" :disabled="disabled" :datas="assetsSubjectList" keyName="code"
                    titleName="name" v-model="form.assetsSubjectCode">
              <template v-slot:item="{ item }">
                {{ item.code }} {{ item.name }}
              </template>
            </Select>
          </FormItem>
        </div>
        <div class="inline-form-item">
          <FormItem label="累计折旧科目" prop="totalDepreciationSubjectCode" required>
            <Select :deletable="false" :disabled="disabled" :datas="totalDepreciationSubjectList" keyName="code"
                    titleName="name" v-model="form.totalDepreciationSubjectCode">
              <template v-slot:item="{ item }">
                {{ item.code }} {{ item.name }}
              </template>
            </Select>
          </FormItem>
          <FormItem label="资产清理科目" prop="assetsCleanSubjectCode" required v-if="User.accountSets.accountStandard != 'ADMINISTRATIVE_PUBLIC_INSTITUTIONS' && User.accountSets.accountStandard != 'GENERAL_CANTEEN' && User.accountSets.accountStandard != 'GENERAL_SCHOOL'">
            <Select :deletable="false" :disabled="disabled" :datas="assetsCleanSubjectList" keyName="code"
                    titleName="name" v-model="form.assetsCleanSubjectCode">
              <template v-slot:item="{ item }">
                {{ item.code }} {{ item.name }}
              </template>
            </Select>
          </FormItem>
          <FormItem label="折旧费用科目" prop="depreciationExpenseSubjectCode" required>
            <Select :deletable="false" :disabled="disabled" :datas="subjectList" keyName="code"
                    titleName="fullName" filterable v-model="form.depreciationExpenseSubjectCode" :filter="filter">
              <template v-slot:item="{ item }">
                <div class="item-text-wrap">
                  {{ item.code }} {{ item.fullName }}
                </div>
              </template>
            </Select>
          </FormItem>
        </div>
        <div class="ml-20px font-bold mb-16px">资产数据</div>
        <div class="inline-form-item">
          <FormItem label="资产原值" prop="originalValue" required>
            <Input type="number" v-model="form.originalValue" :disabled="!form.assetsTypeId || disabled"/>
          </FormItem>
          <FormItem label="残值率(%)" prop="residualRate" required>
            <Input type="number" v-model="form.residualRate" :disabled="!form.assetsTypeId || disabled"/>
          </FormItem>
          <FormItem label="预计残值" prop="expectResidualRateComp">
            <Input type="text" disabled v-model="expectResidualRateComp"/>
          </FormItem>
        </div>
        <div class="inline-form-item">
          <FormItem label="预计使用月份" prop="expectUseMonth">
            <NumberInput type="number" v-model="form.expectUseMonth" :useInt="true" :disabled="!form.assetsTypeId || disabled"/>
          </FormItem>
          <FormItem label="已折旧月份" prop="useMonth" required>
            <NumberInput type="number"   v-model="form.useMonth" :useInt="true" :disabled="!form.assetsTypeId || disabled"/>
          </FormItem>
          <FormItem label="剩余使用月份" prop="remainingUseMonth">
            <NumberInput type="number" disabled :useInt="true" v-model="remainingUseMonthComp"/>
          </FormItem>
        </div>
        <div class="inline-form-item">
          <FormItem label="累计折旧" prop="totalDepreciation">
            <Input type="number" v-model="form.totalDepreciation" :disabled="!form.assetsTypeId || disabled"/>
          </FormItem>
          <FormItem label="本年累计折旧" prop="yearTotalDepreciation">
            <Input type="number" v-model="form.yearTotalDepreciation" :disabled="!form.assetsTypeId || disabled"/>
          </FormItem>
          <FormItem label="以前年度累计折旧" prop="beforeYearTotalDepreciation">
            <Input disabled type="text" v-model="beforeYearTotalDepreciationComp"/>
          </FormItem>
        </div>
        <div class="inline-form-item">
          <FormItem label="每月折旧额" prop="currentMonthDepreciation">
            <Input type="text" v-model="currentMonthDepreciation" disabled/>
          </FormItem>
          <FormItem label="备注" prop="remark">
            <Input type="text" v-model="form.remark"/>
          </FormItem>
          <FormItem/>
        </div>
      </Form>
    </div>
    <div class="modal-column-between">
      <Button @click="$emit('close')">取消</Button>
      <Button color="primary" @click="submit" :loading="loading">{{ form.id ? '更新' : '保存' }}</Button>
    </div>
  </div>
</template>

<script>/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Assets from "@/api/Assets";
import {CopyObj} from "@/js/common/utils";
import {mapState} from "vuex";

import {layer} from "@layui/layer-vue";
import { h} from "vue";
import setting from "@/api/setting";
import DepartmentForm from "@/views/setting/AssistingAccounting/form/DepartmentForm.vue";

export default {
  name: "AssetsForm",
  props: {
    nextCode: String,
    entity: Object,
    checkDate: Object,
    assetsTypeList: Array,
    deptList: Array,
    supplierList: Array,
    subjectList: Array,
  },
  data() {
    return {
      deptLists:[],
      isEdit: false,
      loading: false,
      depreciationMethods: [
        {name: '平均年限法', code: 0},
        {name: '不折旧', code: 1}
      ],
      assetsSubjectList: [],
      totalDepreciationSubjectList: [],
      assetsCleanSubjectList: [],
      form: {
        id: null,
        code: null,
        name: null,
        addType: 1,
        assetsTypeId: null,
        deptId: null,
        supplier: null,
        isPeriod: 0,
        depreciationMethod: 0,
        canEdit: true,
        assetsSubjectCode: null,
        totalDepreciationSubjectCode: null,
        assetsCleanSubjectCode: null,
        depreciationExpenseSubjectCode: null,
        specification: null,
        startDate: null,
        originalValue: null,
        expectUseMonth: null,
        useMonth: 0,
        remainingUseMonth: null,
        residualRate: null,
        expectResidualRate: null,
        totalDepreciation: 0,
        yearTotalDepreciation: 0,
        beforeYearTotalDepreciation: 0,
        currentMonthDepreciation: 0,
        detailCount: 0,
        depreciationCreditSum: 0,
        remark: null,
        isVoucher: false,
        entryDate: this.checkDate.key,
      },
    }
  },
  watch: {
    'form.depreciationMethod'(val) {
      if (this.form.isVoucher) {
        return
      }
      if (val) {
        // this.form.isPeriod = 0;
      }
    },
    'form.assetsTypeId'(val) {
      if (this.form.isVoucher) {
        return
      }
      if (val && !this.isEdit) {
        const assetsType = this.assetsTypeList.find(value => value.id === val);
        this.form.expectUseMonth = assetsType.useMonth;
        this.form.residualRate = assetsType.residualRate;
      }
    }
  },
  computed: {
    ...mapState(['currentAccountSets','User']),
    disabled() {
      return !this.form.canEdit || this.form.isVoucher;
    },
    expectResidualRateComp() {
      if (this.form.originalValue && this.form.residualRate) {
        return Number(this.form.originalValue * (this.form.residualRate / 100)).toFixed(2)
      }
      return 0;
    },
    remainingUseMonthComp() {
      // console.log(this.form.expectUseMonth,this.form.useMonth)
      if (this.form.expectUseMonth && this.form.useMonth) {
        return Number(this.form.expectUseMonth - this.form.useMonth)
      }
      return this.form.expectUseMonth;
    },
    beforeYearTotalDepreciationComp() {
      if (this.form.totalDepreciation || this.form.yearTotalDepreciation) {
        if(this.form.yearTotalDepreciation === undefined){
          this.form.yearTotalDepreciation = 0;
        }
        return Number(this.form.totalDepreciation - this.form.yearTotalDepreciation).toFixed(2)
      }
      return 0;
    },
    currentMonthDepreciation() {
      //jxd不是数值的转换一下，确保计算正确
      // console.log(this.form)
      // console.log(this.disabled,this.form.currentMonthDepreciation)
      // console.log(this.form.originalValue,this.expectResidualRateComp,this.form.totalDepreciation,this.remainingUseMonthComp,this.form.detailCount)
      return this.disabled ? this.form.currentMonthDepreciation : (((this.form.originalValue - Number(this.expectResidualRateComp) - this.form.totalDepreciation) / (this.remainingUseMonthComp + Number(this.form.detailCount))) || 0).toFixed(2);
    }
  },
  methods: {
    // 新增部门
    openDept (entity) {
      let layerId = layer.open({
        title: "部门信息",
        shadeClose: false,
        closeBtn: false,
        zIndex: 1000,
        area: ['700px', 'auto'],
        content: h(DepartmentForm, {
          entity,
          onClose: () => {
            layer.close(layerId);
            this.getDept();
          },
          onSuccess: () => {
            layer.close(layerId);
            this.getDept();
          }
        })
      });
    },
    // 获取部门
    getDept  () {
      console.log("我执行了")
      setting.accountingCategoryDetails.loadAuxiliaryAccountingDataByName(['DEPARTMENT', 'VENDOR']).then(({data}) => {
        this.deptLists = data['DEPARTMENT'].map(val => {
          return {
            key: val.id,
            accountingCategoryId: val.categoryId,
            title: val.name
          }
        });
      })
    },
    filter(item, val) {
      return item.code.indexOf(val) !== -1 || item.name.indexOf(val) !== -1 || item.mnemonicCode.indexOf(val) !== -1;
    },
    submit() {
      if(Number(this.form.yearTotalDepreciation) > Number(this.form.totalDepreciation)){
        this.$Message({
          type:'warn',
          text: `本年累计折旧不能大于累计折旧！`
        });
        return;
      }
      let validResult = this.$refs.form.valid();
      if (validResult.result) {
        this.loading = true;
        this.form.isPeriod = this.form.isPeriod ? 1 : 0;//jxd
        this.form.beforeYearTotalDepreciation = this.beforeYearTotalDepreciationComp;
        this.form.expectResidualRate = this.expectResidualRateComp;
        this.form.remainingUseMonth = this.remainingUseMonthComp;
        //解决当前月折旧为-Infinity和Infinity的问题
        if(this.currentMonthDepreciation == -Infinity || this.currentMonthDepreciation == Infinity){
          this.form.currentMonthDepreciation = 0;
          this.currentMonthDepreciation = 0;
        }else{
          this.form.currentMonthDepreciation = this.currentMonthDepreciation;
        }
        // this.form.currentMonthDepreciation = this.currentMonthDepreciation;
        Assets.save(this.form).then(() => {
          this.$emit('success');
        }).finally(() => {
          this.loading = false;
        })
      }
    }
  },
  created() {
    if(this.entity){
      this.isEdit = true;//jxd编辑的情况下，不需要填充残值率，预计使用月份
      this.entity.isPeriod = this.entity.isPeriod ? 1 : 0;//jxd
    }
    this.deptLists = this.deptList;
    CopyObj(this.form, this.entity);
    // console.log(this.form,this.entity)
    console.log(this.subjectList)
    this.subjectList.forEach(val => {
      if(this.currentAccountSets.accountStandard == "FARMER"){
        if (val.code.toLowerCase().includes('151')) {
          this.assetsSubjectList.push(val);
          if (!this.entity) {
            this.form.assetsSubjectCode = val.code;
          }
        } else if (val.code.toLowerCase().includes('152')) {
          this.totalDepreciationSubjectList.push(val);
          if (!this.entity) {
            this.form.totalDepreciationSubjectCode = val.code;
          }
        } else if (val.code.toLowerCase().includes('154')) {
          this.assetsCleanSubjectList.push(val)
          if (!this.entity) {
            this.form.assetsCleanSubjectCode = val.code;
          }
        } else if (val.name === '折旧费') {
          if (!this.entity) {
            this.form.depreciationExpenseSubjectCode = val.code;
          }
        }
      }else if(this.currentAccountSets.accountStandard == "SELF_EMPLOYED" || this.currentAccountSets.accountStandard == "VILLAGE_COLLECTIVE"){
        if (val.code.toLowerCase().includes('151')) {
          this.assetsSubjectList.push(val);
          if (!this.entity) {
            this.form.assetsSubjectCode = val.code;
          }
        } else if (val.code.toLowerCase().includes('152')) {
          this.totalDepreciationSubjectList.push(val);
          if (!this.entity) {
            this.form.totalDepreciationSubjectCode = val.code;
          }
        } else if (val.code.toLowerCase().includes('153')) {
          this.assetsCleanSubjectList.push(val)
          if (!this.entity) {
            this.form.assetsCleanSubjectCode = val.code;
          }
        } else if (val.name === '折旧费') {
          if (!this.entity) {
            this.form.depreciationExpenseSubjectCode = val.code;
          }
        }
      } else if(this.User.accountSets.accountStandard == "RURAL_COLLECTIVE_ECONOMIC_ORGANIZATIONS"){
        if (val.code.toLowerCase().includes('151')) {
          this.assetsSubjectList.push(val);
          if (!this.entity) {
            this.form.assetsSubjectCode = val.code;
          }
        } else if (val.code.toLowerCase().includes('152')) {
          this.totalDepreciationSubjectList.push(val);
          if (!this.entity) {
            this.form.totalDepreciationSubjectCode = val.code;
          }
        } else if (val.code.toLowerCase().includes('153')) {
          this.assetsCleanSubjectList.push(val)
          if (!this.entity) {
            this.form.assetsCleanSubjectCode = val.code;
          }
        } else if (val.name === '固定资产折旧') {
          if (!this.entity) {
            this.form.depreciationExpenseSubjectCode = val.code;
          }
        }
      }else if(this.currentAccountSets.accountStandard == "TRADE_UNION"){
        if (val.code.toLowerCase().includes('162')) {
          this.assetsSubjectList.push(val);
          if (!this.entity) {
            this.form.assetsSubjectCode = val.code;
          }
        } else if (val.code.toLowerCase().includes('163')) {
          this.totalDepreciationSubjectList.push(val);
          if (!this.entity) {
            this.form.totalDepreciationSubjectCode = val.code;
          }
        } else if (val.code.toLowerCase().includes('182')) {
          this.assetsCleanSubjectList.push(val)
          if (!this.entity) {
            this.form.assetsCleanSubjectCode = val.code;
          }
        } else if (val.name === '折旧费') {
          if (!this.entity) {
            this.form.depreciationExpenseSubjectCode = val.code;
          }
        }
      }else if(this.currentAccountSets.accountStandard == "NONGOVERNMENTAL" || this.currentAccountSets.accountStandard == "NONGOVERNMENTAL2026"){
        if (val.code.toLowerCase().includes('1501')) {
          this.assetsSubjectList.push(val);
          if (!this.entity) {
            this.form.assetsSubjectCode = val.code;
          }
        } else if (val.code.toLowerCase().includes('1502')) {
          this.totalDepreciationSubjectList.push(val);
          if (!this.entity) {
            this.form.totalDepreciationSubjectCode = val.code;
          }
        } else if (val.code.toLowerCase().includes('1509')) {
          this.assetsCleanSubjectList.push(val)
          if (!this.entity) {
            this.form.assetsCleanSubjectCode = val.code;
          }
        } else if (val.name === '固定资产折旧') {
          if (!this.entity) {
            this.form.depreciationExpenseSubjectCode = val.code;
          }
        }
      }else if(this.currentAccountSets.accountStandard == "GENERAL_CANTEEN" || this.currentAccountSets.accountStandard == "GENERAL_SCHOOL"){
        if (val.code.toLowerCase().includes('1501')) {
          this.assetsSubjectList.push(val);
          if (!this.entity) {
            this.form.assetsSubjectCode = val.code;
          }
        } else if (val.code.toLowerCase().includes('1502')) {
          this.totalDepreciationSubjectList.push(val);
          if (!this.entity) {
            this.form.totalDepreciationSubjectCode = val.code;
          }
        } else if (val.code.toLowerCase().includes('1506')) {
          this.assetsCleanSubjectList.push(val)
          if (!this.entity) {
            this.form.assetsCleanSubjectCode = val.code;
          }
        } else if (val.name === '折旧费' || val.name === '资产折旧费用') {
          if (!this.entity) {
            this.form.depreciationExpenseSubjectCode = val.code;
          }
        }
      }else{
        if (val.code.toLowerCase().includes('1601')) {
          this.assetsSubjectList.push(val);
          if (!this.entity) {
            this.form.assetsSubjectCode = val.code;
          }
        } else if (val.code.toLowerCase().includes('1602')) {
          this.totalDepreciationSubjectList.push(val);
          if (!this.entity) {
            this.form.totalDepreciationSubjectCode = val.code;
          }
        } else if (val.code.toLowerCase().includes('1606')) {
          this.assetsCleanSubjectList.push(val)
          if (!this.entity) {
            this.form.assetsCleanSubjectCode = val.code;
          }
        } else if (val.name === '固定资产折旧') {
          if (!this.entity) {
            this.form.depreciationExpenseSubjectCode = val.code;
          }
        }
      }
    })
  }
}
</script>
<style scoped>

.item-text-wrap {
  white-space: normal;
  max-width: 160px;
  overflow: hidden;
}

</style>